<script>
import swal from 'sweetalert2';

export default {
    methods: {
        showRole(role, title) {
            swal({
                type: 'info',
                title: title + ' Permissions',
                html: this.$el.querySelector('[data-role-permissions="' + role + '"]').innerHTML,
            }).catch(swal.noop);
        },
    },
};
</script>
